import { PaintedScene } from '../PaintedScene';

export const ASHVEIN_MARKET_PHASER_KEY = 'AshveinMarketScene' as const;
export const ASHVEIN_MARKET_MANIFEST_KEY = 's-401-ashvein-market' as const;

export class AshveinMarketScene extends PaintedScene {
  constructor() {
    super(ASHVEIN_MARKET_PHASER_KEY, ASHVEIN_MARKET_MANIFEST_KEY);
  }
}
